import { render, staticRenderFns } from "./PercentChange.vue?vue&type=template&id=4f98877e&"
import script from "./PercentChange.vue?vue&type=script&lang=ts&"
export * from "./PercentChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports